var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.isVerify ? _vm.$t("审核") : _vm.$t("查看"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    }
  }, [_c("el-timeline", _vm._l(_vm.scheduleList, function (item, index) {
    return _c("el-timeline-item", {
      key: index,
      attrs: {
        timestamp: item.updateAt,
        placement: "top",
        type: item.status == 3 ? "success" : item.status == 1 ? "info" : item.status == 2 ? "primary" : "warning"
      }
    }, [_c("h4", [_vm._v(" " + _vm._s(item.userType == 1 ? _vm.$t("申请人") + ":" : item.userType == 2 ? _vm.$t("审核人") + ":" : item.userType == 3 ? _vm.$t("抄送人") + ":" : "") + _vm._s(item.userName)), item.userType != 1 && item.status != 1 ? _c("span", {
      staticStyle: {
        "margin-left": "10px",
        display: "inline-block"
      }
    }, [_vm._v("(" + _vm._s(item.status == 3 ? _vm.$t("审核通过") : item.status == 1 ? _vm.$t("待审核") : item.status == 2 ? _vm.$t("审核中") : _vm.$t("已驳回")) + ")")]) : _vm._e()]), _c("p", [_vm._v(_vm._s(item.content ? _vm.$t("审核意见") + ":" + item.content : ""))])]);
  }), 1)], 1), _c("div", {
    staticStyle: {
      flex: "2",
      overflow: "hidden",
      "border-left": "1px solid #f5f5f5"
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.from,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发布客户")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.dataFrom.customerName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerName", $$v);
      },
      expression: "dataFrom.customerName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发布应用")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.dataFrom.applicationName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "applicationName", $$v);
      },
      expression: "dataFrom.applicationName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "versionNumber",
      label: _vm.$t("版本号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("仅支持输入大小写英文字母与数字"),
      disabled: ""
    },
    model: {
      value: _vm.dataFrom.versionNumber,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "versionNumber", $$v);
      },
      expression: "dataFrom.versionNumber"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "platform",
      label: _vm.$t("上线平台")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("多平台用“，”隔开"),
      disabled: ""
    },
    model: {
      value: _vm.dataFrom.platform,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "platform", $$v);
      },
      expression: "dataFrom.platform"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "content",
      label: _vm.$t("优化内容")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请简单描述此次版本更新内容"),
      disabled: ""
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "releaseAt",
      label: _vm.$t("发布日期")
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      disabled: "",
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.dataFrom.releaseAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "releaseAt", $$v);
      },
      expression: "dataFrom.releaseAt"
    }
  })], 1), _vm.dataFrom.apkUrl ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("测试版二维码(安卓)")
    }
  }, [_c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.dataFrom.apkUrl
    }
  })]) : _vm._e(), _vm.dataFrom.iosUrl ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("测试版二维码(iOS)")
    }
  }, [_c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.dataFrom.iosUrl
    }
  })]) : _vm._e(), _vm.dataFrom.isVerify ? _c("a-form-model-item", {
    attrs: {
      prop: "content",
      label: _vm.$t("审核意见")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("审核意见")
    },
    model: {
      value: _vm.from.content,
      callback: function ($$v) {
        _vm.$set(_vm.from, "content", $$v);
      },
      expression: "from.content"
    }
  })], 1) : _vm._e(), _vm.dataFrom.isVerify ? _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 10,
        offset: 8
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("驳回")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.onSubmit(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("审核通过")))])], 1) : _vm._e()], 1)], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };